import { render, staticRenderFns } from "./PlyrWidget.vue?vue&type=template&id=0c48aa94&scoped=true&"
import script from "./PlyrWidget.vue?vue&type=script&lang=ts&"
export * from "./PlyrWidget.vue?vue&type=script&lang=ts&"
import style0 from "vue-plyr/dist/vue-plyr.css?vue&type=style&index=0&lang=css&"
import style1 from "./PlyrWidget.vue?vue&type=style&index=1&id=0c48aa94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48aa94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VIcon,VImg,VRow})
